import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { BotMessage, Faqs, UserMessage } from ".";
import { BotIconWelcomeScreen } from "../icons";
import { Message } from "../interface";

const Messages: React.FC<{
  messages: Message[];
  toggleIsViewable: Function;
  requestChatbotResponse: Function;
  isResponseLoading: boolean;
  onFaqPressed: Function;
}> = ({
  messages,
  toggleIsViewable,
  requestChatbotResponse,
  isResponseLoading,
  onFaqPressed,
}) => {
    const messagesEndRef = useRef<HTMLDivElement>(null);
    const [shouldScroll, setShouldScroll] = useState(false);

    const scrollToBottom = () => {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useLayoutEffect(() => {
      if (shouldScroll) {
        scrollToBottom();
        setShouldScroll(false);
      }
    }, [shouldScroll]);

    useEffect(() => {
      setShouldScroll(true);
    }, [messages]);

    return (
      <div
        className={`messages ${!Array.isArray(messages) || !messages.length ? "centered" : ""}`}
      >
        {Array.isArray(messages) && messages.length ? (
          messages.map(({ bot_response, user_query }, index) => (
            <div key={index} className="message-container">
              <UserMessage key={messages.length + 1} message={user_query} />
              <BotMessage
                key={messages.length + 2}
                data={bot_response}
                showDisclaimer={index === messages.length - 1}
                isResponseLoading={isResponseLoading}
              />
            </div>
          ))
        ) : (
          <div className="outer-welcome-container">
            <div className="welcome-container">
              <BotIconWelcomeScreen />
              <p>👋 Hi there, how may I help you?</p>
            </div>
            {messages.length === 0 ? <Faqs onSend={onFaqPressed} /> : null}
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>
    );
  };

export default Messages;
